
import DataTransferModule from '@/services/dataTransferModule'
import { ModulesMap } from '@/config/data/modulesMaps'

import RegulationsApi from '@/services/apiServiceModules/regulationsApi'
const regulationsApi = new RegulationsApi()

export default class RegulationsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.REGULATIONS, regulationsApi, {
			useCache: true,
		})
	}

	getFilteredBasedRegulations(companyId, query) {
		return new Promise((resolve, reject) => {
			this.getBasedEntities(companyId, query)
				.then((res) => {
					if (query?.regulation_type) {
						return resolve(res.filter((regulation) => regulation.regulation_type === query.regulation_type))
					}
					return resolve(res)
				})
				.catch((err) => {
					reject(err)
				})
		})
	}

	getFilteredRegulations(companyId, query) {
		return new Promise((resolve, reject) => {
			this.getEntities(companyId, query)
				.then((res) => {
					if (query?.regulation_type) {
						return resolve(res.filter((regulation) => regulation.regulation_type === query.regulation_type))
					}
					return resolve(res)
				})
				.catch((err) => {
					reject(err)
				})
		})
	}

	regulationHasMetricType(companyId, entityId, body) {
		const config = {
			apiServiceMethodName: 'regulationHasMetricType',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId,
			},
			...body,
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}

	regulationAddStageAndPlanWorks(companyId, entityId, body) {
		const config = {
			apiServiceMethodName: 'regulationAddStageAndPlanWorks',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
				entityId,
			},
			...body,
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}
}
